module.exports = __webpack_public_path__ + "static/media/photos-home-icon.a3f5448d.svg";